<template>
  <div>
    <ConstructionList></ConstructionList>
  </div>
</template>
<style lang="scss">
.construction_top {
  align-items: center;

  .addConstruction {
    >button {
      margin-left: 8px;
    }
  }
}

.table_second {
  &__innerbox {
    .item {
      margin: 10px 20px;
    }

    .independent {
      vertical-align: top;
      display: inline-block;
    }

    .name {
      background: #eaeaea;
      color: #676767;
      padding: 3px 10px;
      border-radius: 3px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .btn_border {
      padding: 3px 5px;
      border-radius: 5px;
    }

    .inner_name {
      padding-right: 10px;
    }
  }

  &__innerbox__construction {
    padding: 7px 30px;

    &:not(:last-child) {
      border-bottom: 1px dashed #fff;
    }
  }

  &:hover {
    background: #676767 !important;
  }

  background: hsl(0, 0%, 50%);
  color: #fff;
}
</style>

<script>
import mixins from "@/components/mixins.js";
import ConstructionList from "@/components/new_construction/ConstructionList";
export default {
  name: "finish-construction",
  mixins: [mixins],
  components: {
    ConstructionList,
  },
  data() {
    return {
      popupStatus: false,
    };
  },
};
</script>